import { Base } from "ui/Scripts/source/framework/base";
import { Translations } from "ui/Scripts/source/models/translations";

export interface IMessageListItem {
    id: string;
    date: number;
    title: string;
    userName: string;
    userCompanyName: string;
    modifyDate: number;
    requiresReceiptIsRead: boolean;
    requiresReceipt: boolean;
    isRead: boolean;
    isTitle: boolean;

    getStateNumber(): number;
    getStateStr(): string;
    getStateNumberListSection(): number;
    getStateStrListSection(): string;
}

export class MessageListItem implements IMessageListItem {
    id: string;
    date: number;
    title: string;
    userName: string;
    userCompanyName: string;
    modifyDate: number;
    requiresReceiptIsRead: boolean;
    requiresReceipt: boolean;
    isRead: boolean;
    isTitle: boolean;

    constructor();
    constructor(obj: IMessageListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.date = obj && obj.date || null;
        this.title = obj && obj.title || "";
        this.userName = obj && obj.userName || "";
        this.userCompanyName = obj && obj.userCompanyName || "";
        this.modifyDate = obj && obj.modifyDate || 0;
        this.requiresReceiptIsRead = obj && obj.requiresReceiptIsRead || false;
        this.requiresReceipt = obj && obj.requiresReceipt || false;
        this.isRead = obj && obj.isRead || false;
        this.isTitle = obj && obj.isTitle || false;
    }

    static getTitleMessageListItem(title: string): MessageListItem {
        const result = new MessageListItem();
        result.id = Base.getGuid();
        result.title = title;
        result.isTitle = true;
        return result;
    }

    getStateNumber(): number {
        return this.requiresReceipt
            ? (this.requiresReceiptIsRead
                ? 4
                : 1)
            : (this.isRead || this.requiresReceiptIsRead
                ? 3
                : 2);
    }

    getStateStr(): string {
        return this.requiresReceipt
            ? (this.requiresReceiptIsRead
                ? Translations.ReadReceiptGiven
                : Translations.ReadReceiptNotGiven)
            : (this.isRead || this.requiresReceiptIsRead
                ? Translations.ReadImp
                : Translations.Unread);
    }

    getStateNumberListSection(): number {
        return this.requiresReceipt && !this.requiresReceiptIsRead
            ? 1
            : (this.isRead || this.requiresReceiptIsRead
                ? 3
                : 2);
    }

    getStateStrListSection(): string {
        return this.requiresReceipt && !this.requiresReceiptIsRead
            ? Translations.ReadReceiptRequired
            : (this.isRead || this.requiresReceiptIsRead
                ? Translations.ReadImpPlur
                : Translations.Unread);
    }
}